import React from 'react';
import type ServicedeskCmdbObjectSchemaConfigurationType from '@atlassian/jira-spa-apps-servicedesk-cmdb-object-schema-configuration/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbObjectSchemaConfiguration = lazyForPaint<
	typeof ServicedeskCmdbObjectSchemaConfigurationType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-object-schema-configuration", jiraSpaEntry: "async-servicedesk-object-schema-configuration" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-object-schema-configuration'
		),
);

const ObjectSchemaConfiguration = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbObjectSchemaConfiguration}
		pageId="spa-apps/servicedesk/insight/cmdb-object-schema-configuration"
		shouldShowSpinner
	/>
);

export default ObjectSchemaConfiguration;
